(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-inventory"] && !Shopify.designMode) return;
  try {
    class ProductInventory extends HTMLElement {
  constructor() {
    super();
  }
}

customElements.define('product-inventory', ProductInventory);
  } catch(e) { console.error(e); }
})();

})();
